import TopicPage from './TopicPage';
import TopicPageContainer from './TopicPage.container';

export default TopicPageContainer(TopicPage);
